var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#facdd6}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43 23.93c0-3.39.04-6.77-.02-10.16-.03-1.31.52-2.09 1.6-2.7 2.22-1.25 4.41-2.56 6.61-3.84 2.22-1.29 4.44-2.56 6.66-3.85 1.13-.65 2.25-1.34 3.4-1.96.65-.35 1.23-.81 2.06-.84.99-.04 1.69.5 2.45.93 2.01 1.14 4.01 2.32 6.01 3.48 2.17 1.26 4.35 2.52 6.52 3.78 1.52.88 3.04 1.77 4.55 2.67.74.44 1.08 1.16 1.08 1.98.02 7.02.01 14.05 0 21.07 0 1-.56 1.7-1.39 2.19-2.15 1.24-4.31 2.45-6.45 3.7-3.24 1.89-6.47 3.8-9.7 5.69-.51.3-1.02.58-1.53.87-1.02.57-1.98.5-2.99-.09-2.61-1.55-5.25-3.04-7.87-4.56-2.19-1.27-4.37-2.55-6.55-3.82L4.6 36.58c-.77-.45-1.17-1.1-1.17-2.02.01-3.56 0-7.1 0-10.63zm16.96-9.78h-4.14c-1.33 0-2.11.75-2.11 2.07-.01 2.8.01 5.59-.01 8.39 0 .61.2 1.09.64 1.52 2.89 2.87 5.77 5.76 8.65 8.64.9.9 2.08.91 2.98.01 2.78-2.77 5.55-5.55 8.32-8.32.91-.91.93-2.08.03-2.99-2.89-2.9-5.78-5.79-8.68-8.68-.44-.44-.96-.64-1.59-.63-1.36 0-2.73-.01-4.09-.01z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 14.15c1.36 0 2.73.01 4.09-.01.63-.01 1.15.2 1.59.63 2.89 2.89 5.79 5.78 8.68 8.68.91.91.89 2.08-.03 2.99-2.77 2.78-5.55 5.55-8.32 8.32-.9.9-2.08.89-2.98-.01-2.88-2.88-5.76-5.77-8.65-8.64-.44-.43-.64-.91-.64-1.52.01-2.8 0-5.59.01-8.39 0-1.32.78-2.07 2.11-2.07 1.38.01 2.76.02 4.14.02zm-1.61 6.59c1.13-.01 1.97-.85 1.96-1.97-.02-1.12-1.09-1.97-2-1.92-1.1.07-1.9.85-1.89 1.99.01 1.12.82 1.91 1.93 1.9z",
    style: {
      fill: "#e93958"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.78 20.74c-1.11.01-1.92-.79-1.92-1.89-.01-1.14.79-1.93 1.89-1.99.9-.05 1.98.8 2 1.92 0 1.11-.84 1.96-1.97 1.96z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels);
export default __webpack_public_path__ + "static/media/labels.5b7ab598d922fc1382b690b187d33de4.svg";
export { ForwardRef as ReactComponent };